// Use environment variables with fallbacks
const API_BASE = 'https://api-service-jfzr.onrender.com/api';
const IMAGE_BASE = 'https://api-service-jfzr.onrender.com/api/image/file';

// Cache configuration
const CACHE_TTL = parseInt( '86400') * 1000; // Convert to milliseconds

// Upstash configuration
const UPSTASH_URL = 'https://perfect-porpoise-51669.upstash.io';
const UPSTASH_TOKEN = 'AcnVAAIjcDFmODg3MGY4Y2QzYzc0MjNhOTgyYTI1ZTExYmYxNzYzYXAxMA';

export {
  API_BASE, 
  IMAGE_BASE,
  CACHE_TTL,
  UPSTASH_URL,
  UPSTASH_TOKEN
}

// Production configuration (commented out)
// const API_BASE = 'https://api-service-jfzr.onrender.com/api';
// const IMAGE_BASE = 'https://api-service-jfzr.onrender.com/api/image/file';
